var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSideBarReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Report@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Report",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#B7844D",
    strokeWidth: 1.35,
    x: 3.675,
    y: 4.675,
    width: 16.65,
    height: 15.65,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8954846,9.37684995 L9.44338659,9.37684995 L8.9980863,8.04911563 C8.9686179,7.95964957 8.889213,7.9 8.79999578,7.9 C8.71077856,7.9 8.63136842,7.95964404 8.60190525,8.04911563 L8.15660497,9.37684995 L6.70450693,9.37684995 C6.61446407,9.37901095 6.53547094,9.44211252 6.50927681,9.53331238 C6.482673,9.62450781 6.51459746,9.72304561 6.58826889,9.77836788 L7.75223145,10.6004235 L7.31102792,11.9168721 C7.28074122,12.0072034 7.30857227,12.1074794 7.3801972,12.1658223 C7.45141277,12.2246022 7.55045908,12.2280598 7.62535335,12.1748986 L8.80000311,11.342907 L9.97873916,12.1748986 C10.0131184,12.1991021 10.0536376,12.2125 10.0949783,12.2125 C10.1633282,12.2125 10.2271748,12.1779236 10.266466,12.1191437 C10.3061669,12.0603638 10.3159897,11.9847327 10.2930698,11.9168744 L9.84776954,10.6004258 L11.0117321,9.7783702 C11.0854026,9.72304794 11.1173259,9.62450792 11.0907242,9.5333147 C11.06453,9.44211927 10.985539,9.37902091 10.8954941,9.37685228 L10.8954846,9.37684995 Z M9.48424944,10.3315905 C9.40403042,10.3877769 9.37047259,10.4936626 9.40239277,10.589182 L9.68725922,11.4380358 L8.91616676,10.8934545 C8.8457695,10.8441834 8.75408794,10.8441834 8.68368858,10.8934545 L7.91259613,11.4380358 L8.19746258,10.5861614 C8.22774929,10.4915084 8.19418831,10.3873443 8.11560591,10.3315905 L7.39485858,9.82244865 L8.30551338,9.82244865 C8.39596487,9.82115201 8.47536663,9.75891435 8.50237802,9.66772335 L8.79992243,8.78256713 L9.09746685,9.66772335 C9.12693525,9.75632527 9.20551241,9.81553337 9.29433148,9.81596489 L10.2049863,9.81596489 L9.48424944,10.3315905 Z",
    id: "Shape",
    fill: "#B7844D",
    stroke: "transparent",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.79990557,
    y1: 2,
    x2: 7.79990557,
    y2: 6.962227,
    id: "Path-13",
    stroke: "#B7844D"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.7999056,
    y1: 2,
    x2: 16.7999056,
    y2: 6.96222668,
    id: "Path-13",
    stroke: "#B7844D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#B7844D",
    strokeWidth: 0.6,
    x: 6.9,
    y: 13.3,
    width: 3.9,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#B7844D",
    strokeWidth: 0.6,
    x: 12.9,
    y: 8.3,
    width: 3.9,
    height: 9.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarReports);
export default __webpack_public_path__ + "static/media/SideBarReports.708148a26959611a7045359ad9c520da.svg";
export { ForwardRef as ReactComponent };